import * as React from 'react';
import { flow, forEach, map, first } from 'lodash';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { IQuoteState } from '../../../../services/quote/models';
import { IBenefit, IPremium } from '../../../../data/api/models';
import FaChevronCircleRight from 'react-icons/fa/chevron-circle-right';

interface IBenefitsSectionProps {
  quote: IQuoteState;
}

interface IBenefitsSectionStates {
  viewFullBenefits: boolean;
}

class BenefitsSection extends React.Component<IBenefitsSectionProps, IBenefitsSectionStates> {
  public state = {
    viewFullBenefits: false,
  };

  private toggleViewBenefits = () => {
    this.setState((prevState) => ({
      viewFullBenefits: !prevState.viewFullBenefits,
    }));
  }

  private benefitFormat = (value: string) => {
    return value === 'n/a' || value === 'nil' || !value ? 'x' : value;
  }

  private benefitsRow = (benefit: IBenefit, premiumSelected, key, subBenefit: boolean = false) => {
    // const { viewFullBenefits } = this.state;

    const name = benefit.shortName ? benefit.shortName : benefit.name;
    let excess = this.benefitFormat(benefit.excess);
    let limit = this.benefitFormat(benefit.text);

    // If nothing on top level then use from first sub benefit
    if (benefit.subBenefits && benefit.subBenefits.length > 0) {
      if (excess === 'x') {
        excess = this.benefitFormat(first(benefit.subBenefits).excess);
      }

      if (limit === 'x') {
        limit = this.benefitFormat(first(benefit.subBenefits).text);
      }
    }

    return (
      <div key={key} className="quote-summary-section">
        <span>{name}:</span>
        <div className="quote-summary-info">
          {limit}
        </div>
      </div>
    );
  }

  private renderBenefits = (selectedPremium: IPremium) => {
    if (!selectedPremium) {
      return null;
    }

    return map(selectedPremium.benefits, (benefit: IBenefit, key) => {
      return this.benefitsRow(benefit, selectedPremium, key);
    });
  }

  public render() {
    const { quote } = this.props;
    const { viewFullBenefits } = this.state;

    let selectedPremium: IPremium = null;

    const quotes = quote.quotes ? quote.quotes : [];

    forEach(quotes, (quote) => {
      forEach(quote, (premium) => {
        selectedPremium = premium;
      });
    });

    const MIN_NUMBER_OF_BENEFITS = 3;

    let benefits = this.renderBenefits(selectedPremium);

    if (! viewFullBenefits && benefits) {
      benefits = benefits.slice(0, MIN_NUMBER_OF_BENEFITS);
    }
    return (
      <div>
        <div className="quote-details">
          <div className="info-title">
            <FaChevronCircleRight/>
            KEY BENEFITS
          </div>

          {selectedPremium && (
            <div className="quote-summary-section">
              <span>Standard Excess:</span>
              <div className="quote-summary-info">
                {selectedPremium.information.standardExcess}
              </div>
            </div>
          )}

          {benefits}
          <div className="">
            <Button
              bsStyle="default"
              block={true}
              onClick={this.toggleViewBenefits}
            >
              {viewFullBenefits ? 'Hide' : 'More info'}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state) => {
      return {
        quote: state.quote,
      };
    },
  ),
])(BenefitsSection);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/BenefitsSection/index.tsx